import { ColorOptions } from '@jfs/ui-new'
import { DropdownTypes } from '../../components/DropdownNew/types'
import { getMerchantMappingApprovalApi } from '../../network/getMerchantMappingApprovalApi'
import { getPosBatchCheckerApi } from '../../network/getPosBatchCheckerApi'
import { getPosBatchMakerApi } from '../../network/getPosBatchMakerApi'

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

export const getMakerCheckerData = {
  MERCHANT_MAPPING_APPROVALS: () => ({
    headerTitle: 'Merchant Mapping Approvals',
    getListApi: getMerchantMappingApprovalApi,
    exportJobType: 'MERCHANT_CONFIG_CHECKER_EXPORT',
    headerRowKeys: {
      merchantId: 'Merchant Id',
      merchantType: 'Merchant Type',
      workflowState: 'Workflow State',
      processingEntityID: 'Processing EntityID',
      txnType: 'Txn Type',
      instrumentType: 'Instrument Type',
      opsMakerUserName: 'OpsMaker UserName',
      opsMakerActionType: 'Ops MakerActionType',
      txnMode: 'Txn Mode',
      bankMID: 'Bank MID',
      mappingStatus: 'Mapping Status',
      reqType: 'Req Type',
      pgSecurityId: 'Pg SecurityId',
      secret: 'Req Type',
      cipher: 'Cipher',
      merchantCfg1: 'Merchant Cfg1',
      merchantCfg2: 'Merchant Cfg2',
      emiCode: 'Emi Code',
      terminalId: 'Terminal Id',
    },
    enableFilter: false,
    showCalendar: false,
    showRefresh: false,
  }),
  BATCH_MAKER: (entityList) => ({
    headerTitle: 'POS Batch List',
    getListApi: getPosBatchMakerApi,
    exportJobType: 'BATCH_CLOSURE_EXPORT',
    headerRowKeys: {
      mid: 'Merchant Id',
      tid: 'Terminal Id',
      bankMid: 'Bank Merchant Id',
      bankTid: 'Bank Terminal Id',
      batchNo: 'Batch No',
      status: 'Status',
      processingEntityId: 'Processing Entity',
      createdAt: 'Created',
      actionDownload: '',
    },
    filterData: [
      {
        labelKey: 'status',
        labelDescription: 'By Status',
        singleSelection: true,
        defaultSelected: ['FAILED'],
        checkBoxItems: [
          {
            key: 'FAILED',
            description: 'FAILED',
          },
          {
            key: 'PARTIAL_SUCCESS',
            description: 'PARTIAL SUCCESS',
          },
          {
            key: 'INPROGRESS',
            description: 'IN PROGRESS',
          },
          {
            key: 'COMPLETED',
            description: 'COMPLETED',
          },
        ],
      },
      {
        labelKey: 'processingEntity',
        labelDescription: 'By Procsessing Entity',
        singleSelection: true,
        componentType: 'dropdown',
        data: entityList,
        showSearch: true,
        maxHeight: 400,
        type: DropdownTypes.SELECTABLE_HIGHLIGHT,
      },
      {
        labelKey: 'mid',
        labelDescription: 'By Merchant Id',
        singleSelection: true,
        componentType: 'inputText',
        label: 'Merchant Id',
        ...textinputStyle,
      },
    ],
    enableFilter: true,
    showCalendar: true,
    showRefresh: true,
  }),
  BATCH_CHECKER: () => ({
    headerTitle: 'POS Batch List',
    getListApi: getPosBatchCheckerApi,
    exportJobType: 'BATCH_CLOSURE_REVIEW_EXPORT',
    headerRowKeys: {
      mid: 'Merchant Id',
      tid: 'Tid',
      bankMid: 'Bank Mid',
      bankTid: 'Bank Tid',
      batchNo: 'Batch No',
      status: 'Status',
      processingEntityId: 'Processing EntityId',
      opsMakerUserName: 'Ops MakerUserName',
      makerRequestType: 'Request Type',
      createdAt: 'Created At',
      actionDownload: '',
    },
    filterData: [
      {
        labelKey: 'status',
        labelDescription: 'By Status',
        defaultSelected: ['APPROVAL_IN_PROGRESS'],
        checkBoxItems: [
          {
            key: 'FAILED',
            description: 'FAILED',
          },
          {
            key: 'COMPLETED',
            description: 'COMPLETED',
          },
          {
            key: 'RETRY_IN_PROGRESS',
            description: 'RETRY_IN_PROGRESS',
          },
          {
            key: 'CLOSURE_IN_PROGRESS',
            description: 'CLOSURE_IN_PROGRESS',
          },
          {
            key: 'APPROVAL_IN_PROGRESS',
            description: 'APPROVAL_IN_PROGRESS',
          },
        ],
      },
    ],
    enableFilter: true,
    showCalendar: true,
    showRefresh: true,
  }),
}

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    batchNo: 100,
    mid: 100,
    tid: 100,
    bankMid: 100,
    bankTid: 100,
    status: 200,
    processingEntityId: 100,
    actionDownload: 150,
    opsMakerUserName: 200,
    makerRequestType: 200,
    createdAt: 200,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

export const getDefaultFilterData = (filterdata = []) =>
  filterdata?.reduce((acc, category) => {
    acc[category.labelKey] = category?.checkBoxItems
      ?.map((item) => ({
        ...item,
        isChecked: category?.defaultSelected?.includes(item?.key) ? true : false,
      }))
      ?.filter((item) => item?.isChecked)
    return acc
  }, {})
